import { cm } from '~/utils/utils'

export interface ContextBlockProps {
  text?: BlockText | null
  fields?: {
    align?: 'center' | 'left' | 'right'
  }
}

export function ContextBlock({ text, fields }: ContextBlockProps) {
  const value = text?.text || ''
  const align = fields?.align || 'left'
  return <div className={cm('mx-[40px] mb-5', `text-${align}`)}>{value}</div>
}
